var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66663 4.16666L4.66663 3.16666V6.83332M4.66663 6.83332H3.66663M4.66663 6.83332H5.33329M9.33328 9.49999H8.27078C7.78362 9.49999 7.5121 8.95724 7.77048 8.57157C7.80231 8.52405 7.84737 8.4874 7.89499 8.45572L9.09489 7.65729C9.14251 7.62561 9.18742 7.58881 9.21993 7.54175C9.51685 7.11188 9.21415 6.49999 8.66834 6.49999H7.66663M11.6666 9.83332H12.6309C13.4539 9.83332 13.5999 11.0917 12.84 11.3038C12.8032 11.314 12.7647 11.3181 12.7265 11.3195L12.3333 11.3333L12.7265 11.3472C12.7647 11.3485 12.8032 11.3526 12.84 11.3629C13.5999 11.5749 13.4539 12.8333 12.6309 12.8333H11.6666",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderedList);
export default __webpack_public_path__ + "static/media/orderedList.4e7f749ac52fd740eaa836c34da6a05b.svg";
export { ForwardRef as ReactComponent };